import { createGlobalStyle } from "styled-components";
export default createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html{
    font-size: 62.5%; // A cada 1rem será considerado 10px
  }

/**************************************************************************/
//                            MEDIA QUERYS                                //
/**************************************************************************/
  @media screen and (max-width: 1366px) {
    html{font-size: 55%;}
  };
  @media screen and (max-width: 768px) {
    html{font-size: 50%;}
  };
/**************************************************************************/
////////////////////////////////////////////////////////////////////////////
/**************************************************************************/

  #root{
    margin: 0 auto;
  }

  body{
    font-size: 1.6rem;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;
    width: 100%;
    height: 100vh;
  }

  body,input,button{
    font-family: Montserrat, sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  button, a, Link{
    cursor: pointer;
  }
  
  p,h1,h2,h3,h4,h5,h6{
    margin: 0;
  }
`;

/**************************************************************************/
//                         PALETA DE CORES                                //
/**************************************************************************/

export const colorPallet = {
  darkBlue: "#071242",
  lightBlue: "#90CBF0",
  lightBlue2: "#90cbf07a",
  whiteBlue: "#eef7fd",
  beigeSalmon: "#D98772",
  yellow: "#FBBC56",
  grey: "#787878",
};
/**************************************************************************/
////////////////////////////////////////////////////////////////////////////
/**************************************************************************/
